import React from 'react';

import {SchemaTag} from 'folder-items/FileConstants';
import {ElementKeyboardEvent} from 'util/Types';

import NumericValueEditor from './NumericValueEditor';

interface FloatValueEditorProps {
  autoFocus: boolean;
  defaultValue?: SchemaTag;
  onChange: (value: {floatValue: number | null; value: string}) => void;
  onKeyDown?: (e: ElementKeyboardEvent) => void;
  placeholder?: string;
  isDisabled?: boolean;
}

export default function FloatValueEditor(props: FloatValueEditorProps): JSX.Element {
  return (
    <NumericValueEditor
      {...props}
      valueAccessorKey="floatValue"
      useStringValue={true}
      placeholder={props.placeholder ?? 'Floating Point Value'}
    />
  );
}
